<template>
  <div>
    <div class="common-box border-t0">
      <el-form class="form-single-inline" :inline="true" :model="formInlieOne" style="margin-top: 28px;">
        <el-form-item>
          <el-input v-model="formInlieOne.keyWords" placeholder="请输入姓名/手机号/客户号" style="width:320px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="search" @click="search">查询 <i class="el-icon-search"></i></el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" element-loading-text="加载中..." :data="tableOne" class="table-single margin-t20">
        <el-table-column label="序号" prop="rowNum" width="100"></el-table-column>
        <el-table-column label="客户名称" prop="custName"></el-table-column>
        <el-table-column label="客户号" prop="custNo"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="本月成交量(元)" prop="monthMoney"></el-table-column>
        <el-table-column label="总成交量(元)" prop="totalMoney"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="table-single-btn-font" @click="detailsClick(scope.row)">详情</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination class="pagination-single" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="page" :page-size="pageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
      </el-pagination>
    </div>
    <!-- 数量统计 -->
    <div class="common-box" style="min-height:0;">
      <ul class="statisticsBox clearfix">
        <li><span>本月累计销量</span><span>{{$commonJs.formatNumber(privateCount.thisMonthSales)}}</span></li>
        <li><span>当季累计销量</span><span>{{$commonJs.formatNumber(privateCount.thisQuarterSales)}}</span></li>
        <li><span>今年累计销量</span><span>{{$commonJs.formatNumber(privateCount.thisYearSales)}}</span></li>
        <li><span>累计总销量</span><span style="margin-right: 0;">{{$commonJs.formatNumber(privateCount.totalSales)}}</span></li>
      </ul>
    </div>
  </div>

</template>

<script>
export default {
  name: 'privateSales',
  data () {
    return {
      tableOne: [],
      formInlieOne: {
        keyWords: ''
      },
      loading: true,
      page: 1,
      pageNum: 10,
      total: 0,
      privateCount: {
        thisMonthSales: '--',
        thisQuarterSales: '--',
        thisYearSales: '--',
        totalSales: '--',
      }
    }
  },
  mounted () {
    this.getPrivateStatistics()
    this.getPrivateCount()
  },
  methods: {
    handleCurrentChange (newPage) {
      this.page = newPage
      this.loading = true
      this.getPrivateStatistics()
    },
    handleSizeChange (newSize) {
      this.pageNum = newSize
      this.loading = true
      this.getPrivateStatistics()
    },
    search () {
      this.loading = true
      this.getPrivateStatistics()
    },
    // 私募销量
    getPrivateStatistics () {
      this.$http.post(this.$apiPath.getAdvisorPFSalesStatistics, {
        AdviserCode: this.$commonJs.getCookie('code'),
        keyWords: this.formInlieOne.keyWords,
        page: this.page,
        pageNum: this.pageNum,
      }).then(res => {
        // console.log(res);
        this.loading = false
        if (res.data.code == 200) {
          this.tableOne = res.data.data.list
          this.total = res.data.data.recordCount
        }
      }).catch(err => { })
    },
    // 私募详情
    detailsClick (row) {
      const { href } = this.$router.resolve({
        name: 'privateSalesDetails',
        query: {
          custon: row.custNo,
          time: row.relationDate,
          name: row.custName
        }
      })
      window.open(href, '_blank')
    },
    // 私募统计
    getPrivateCount () {
      this.$http.post(this.$apiPath.getAdvisorPFSalesStatisticsTotal, {
        AdviserCode: this.$commonJs.getCookie('code'),
      }).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          this.privateCount = res.data.data
        }
      }).catch(err => { })
    }
  }
}
</script>

<style lang="less" scoped>
</style>